import {  Grid, TextField, Button, IconButton } from '@material-ui/core';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
//import Alert from '@material-ui/lab/Alert';
import StatusDisplay from './StatusDisplay'
import { forgotPasswordRequest,confirmForgotPassword} from '../Services/authService';

const useStyles = makeStyles((theme) => ({
    signinbtn: {
        fontFamily: 'Open Sans',
        fontWeight: 400,
        fontSize: 18,
        backgroundColor: "#1867B8",
        width: '50%',
        height: 40,
        color: '#FFFFFF',
        margin: '20px auto',
        display: 'block',
        borderRadius: 0,
        '&:hover': {
            backgroundColor: "#1867B8",
            color: '#FFFFFF',
        }

    }
}));

const ForgotPassowrdDialog = ( {open,signinlabel,closeCallback,clientId
        ,isRunning,setIsRunning,successMessage,setSuccessMessage,error,setError
        ,handleError, user} )=>{

    const classes = useStyles();
    const [cognitoResult, setCognitoResult] = useState();
    const [code, setCode] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    let username = user; 

    const handleResetPassword = (e) => {
        setError("");
        //setUsername(username);
        if (!username) {
            handleError('ValidateUserName');
            
        }else if(/\s/g.test((username))){
            handleError('InvalidUsername');
        }else if(cognitoResult && cognitoResult.data && cognitoResult.data.CodeDeliveryDetails) {
            if(password === password2){
            setIsRunning(true);
            confirmForgotPassword(username,code,password,clientId).then(result => {
                setCognitoResult(result);
                setSuccessMessage("Password reset successfully");
                handleClose();
            }).catch(error => {
                handleError(null,error);
            }).finally(()=>{
                setIsRunning(false);
            });
            }else{
                handleError("ConfirmPasswordNotMatchException");
            }
        }else{
            setIsRunning(true);
            forgotPasswordRequest(username,clientId).then(result => {
                setCognitoResult(result);
            }).catch(error => {
                handleError(null,error);
            }).finally(()=>{
                setIsRunning(false);
            });
        }
    };
    const handleClose=()=>{
        setCognitoResult(null);
        //setUsername("");
        const newpwd = password;
        setCode("");
        setPassword("");
        setPassword2("");
        closeCallback(newpwd);
    };

    return (
        <Dialog fullWidth={true} open={open} maxWidth='sm' disableBackdropClick disableEscapeKeyDown  aria-labelledby="max-width-dialog-title">
            <Grid item xs={12} container>
                <Grid item xs={11}> <DialogTitle id="verify-authapp-user-dilaog">{signinlabel.ForgotPasswordLabels}</DialogTitle> </Grid>
                <Grid item xs={1}> <IconButton onClick={handleClose}> <CloseIcon /> </IconButton> </Grid>
            </Grid>
        <DialogContent>                                    
            <div style={{ height: '470px', width: '100%' }}>
                {/* <div style={{ marginBottom: '20px' }}>{signinlabel.ForgotPasswordInstructionText}</div> */}
                <div style={{ marginBottom: '20px' }}>{(cognitoResult && cognitoResult.data && cognitoResult.data.Message && cognitoResult.data.Message ==="ResetPasswordSuccess")?(signinlabel.ForgotPasswordSuccessText):(signinlabel.ForgotPasswordInstructionText)}</div>
                <StatusDisplay isRunning={isRunning}  successMessage={successMessage} setSuccessMessage={setSuccessMessage} error={error} setError={setError} ></StatusDisplay>
                <div className={classes.usernamelbl}><label>{signinlabel.UserNameLabels}</label> </div>
                <TextField name="txtusernameforgotpass" variant="outlined" type="text" onChange={(e=>{ username=( (!cognitoResult)? e.target.value:username) })} defaultValue={username} fullWidth/>
                { (cognitoResult && cognitoResult.data && cognitoResult.data.CodeDeliveryDetails && cognitoResult.data.CodeDeliveryDetails.DeliveryMedium)? (
                <div className={classes.usernamelbl}>
                    <label>{signinlabel.NewPasswordLabels}</label><br></br>
                    <TextField  name="txtpasswordforgotpass" autoFocus variant="outlined" type="password" onChange={(e=>{ setPassword( e.target.value) })} value={password}   /><br/>
                    <label>{signinlabel.ConfirmNewPasswordLabels}</label><br></br>
                    <TextField  name="txtpasswordforgotpass2" variant="outlined" type="password"onChange={(e=>{ setPassword2( e.target.value) })} value={password2} /><br/>
                    <label>{signinlabel.VerifyUserTitle} {cognitoResult.data.CodeDeliveryDetails.DeliveryMedium.Value+"-:-"+cognitoResult.data.CodeDeliveryDetails.Destination} </label><br></br>
                    <TextField  name="txtcodeforgotpass" variant="outlined"  type="text" onChange={(e=>{ setCode( e.target.value) })} value={code}  />
                </div>
                ):("")}
                {/* <Button variant="contained" color="primary" onClick={handleResetPassword} className={classes.signinbtn}> {signinlabel.ResetPasswordLabels} </Button> */}
                <Button variant="contained" color="primary" onClick={(cognitoResult && cognitoResult.data && cognitoResult.data.Message && cognitoResult.data.Message ==="ResetPasswordSuccess")?(handleClose):(handleResetPassword)} className={classes.signinbtn}> {(cognitoResult && cognitoResult.data && cognitoResult.data.Message && cognitoResult.data.Message ==="ResetPasswordSuccess")?("OK"):(signinlabel.ResetPasswordLabels)} </Button>
            </div>
        </DialogContent>
    </Dialog>
    );
}
export default ForgotPassowrdDialog;